export default "__VITE_ASSET__CRn_LMUA__"